import type { Control } from "react-hook-form";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import type {
	LandFormInput,
	LandFormOutput,
} from "web_myplann/Portfolio/Forms/LandForm/landFormSchema";
import { FlatRowFormInput } from "web_myplann/Shared/Components/FlatRow/FlatRowFormInput";

type Props = {
	control: Control<LandFormInput, unknown, LandFormOutput>;
	isLast?: boolean;
};

const PageResources = Resources.Portfolio.AddLand;

export const LandValueField = ({ control, isLast = false }: Props) => {
	const { t } = useResource();

	return (
		<FlatRowFormInput
			control={control}
			name="landValue"
			type="number"
			label={t(PageResources.Fields.value)}
			placeholder={t(Resources.Portfolio.AddShared.Placeholders.fill)}
			suffix={t(Resources.Common.CurrencySign)}
			isLast={isLast}
		/>
	);
};
